export default "__VITE_ASSET__49154733__"